import React from "react";

function HowItWorks() {
    return (
        <>
            <div id="how-it-works-section" className="how-it-works">
                <div className="container">
                    <div className="row section">
                        <div className="col-12 how-works-desc">
                            IdentityForce helps protect you from identity theft. We're always monitoring your personal information to protect your identity,
                            privacy, and credit, and will rapidly alert you to any suspicious activity. If we find that a criminal uses your information illegally,
                            you'll know. And, if that happens, we'll help restore any damage that is done. Enroll today — it's fast and easy.
                        </div>

                        <div className="col-10 col-sm-10 col-md-5 offset-md-1 offset-sm-1 offset-xs-1">
                            <h4>Enrollment</h4>
                            <div>
                                <p>
                                    Upon order completion, we will send you a "Welcome" email explaining your member benefits, and a link to your secure online
                                    member dashboard.
                                </p>
                            </div>
                            <div>
                                <p>Next, you will complete your profile and provide us with important monitoring information.</p>
                            </div>
                            <div>
                                <p>Only you will enter highly sensitive information — like your social security number — through your secure online dashboard.</p>
                            </div>
                        </div>

                        <div className="col-10 col-sm-10 col-md-5 offset-md-0 offset-sm-1 offset-xs-1">
                            <h4>After Enrollment</h4>
                            <div>
                                <p>You'll be notified via text and e-mail alerts when we detect suspicious activity, so you can take immediate action.</p>
                            </div>
                            <div>
                                <p>
                                    Each month, we will send you an account update with an overview of all account activity, including alerts youʼve received and a
                                    summary of your member benefits.
                                </p>
                            </div>
                            <div>
                                <p>
                                    You'll get 24/7 access to your dashboard for important alerts, reports, and breaking news about threats, scams, and data
                                    breaches.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HowItWorks;
